import { Component, OnInit, Input } from '@angular/core';

/**
 * @deprecated this component is no longer used, but now we use the same preview component 
 * to show a message when the preview is not found.
 */

@Component({
    selector: 'core-preview-not-found',
    templateUrl: './preview-not-found.component.html',
    styleUrls: ['./preview-not-found.component.scss'],
    providers: []
})
export class PreviewNotFoundComponent implements OnInit {


    @Input() file: any = null;

    public alt:string;

    ngOnInit(){
        // this.alt = "file-" + this.file;
        this.alt = "preview-not-found";
    }

}
